// libraries.
import { useNavigate } from "react-router-dom";

// components.
import { SidebarButton } from "@shared/Sidebar/components/SidebarButton/SidebarButton";
import { useSidebarContext } from "@shared/Sidebar";

// types.
import { SIDEBAR_BUTTON_RULES } from "../sidebarHome.types";

// assets.
import { IconRules } from "@assets";
import { pathRules } from "@routes/routes.types";
import { pathRulesMain } from "@pages/RulesPage/routes/routes.types";

export const ButtonRules = () => {
  const navigate = useNavigate();
  const {
    setSelectedButton,
    state: { selectedSidebarButton },
  } = useSidebarContext();

  const handleOnClick = () => {
    setSelectedButton(SIDEBAR_BUTTON_RULES);
    navigate(`${pathRules}/${pathRulesMain}`);
  };

  return (
    <SidebarButton
      hoverText="Reglas"
      onClick={handleOnClick}
      selected={selectedSidebarButton === SIDEBAR_BUTTON_RULES}
    >
      <IconRules fill="white" />
    </SidebarButton>
  );
};

